import React, { useEffect, useRef, useState } from 'react';

const RedrawLayoutButton = ({uuid, setRedrawRequested, redrawInProgress}) => {
  const buttonRef = useRef();
  const spacingRef = useRef(0);
  const [spacing, setSpacing] = useState(0);

  const handleClick = (e) => {
    e.preventDefault();
    setRedrawRequested(() => true);
  }

  useEffect(() => {
    if(setRedrawRequested != undefined) { setTimeout( () => setRedrawRequested( () => true), 250) }
  }, [uuid])

  // The button's bottom lines up with the bottom of the drawing beside it, unless the form is taller or a narrow screen
  // stacks the two. The form column scrolls past its maximum height, so the button is never pushed beyond it. What
  // sits above the drawing (its templates' buttons, a warning) moves it, so both columns are watched.
  useEffect(() => {
    if(uuid == undefined || typeof ResizeObserver === 'undefined') { return; }

    const drawing = document.getElementById(`layout_svg_${uuid}`);
    const column = buttonRef.current && buttonRef.current.closest('.layout-col-cont');
    if(drawing == null || column == null) { return; }

    const align = () => {
      const buttonBox = buttonRef.current.getBoundingClientRect();
      const drawingBox = drawing.getBoundingClientRect();
      let next = 0;
      if(drawingBox.height > 0 && drawingBox.left >= buttonBox.right) {
        const maximumHeight = parseFloat(getComputedStyle(column).maxHeight);
        const room = Number.isNaN(maximumHeight) ? Infinity : maximumHeight - (column.scrollHeight - spacingRef.current);
        next = Math.round(Math.max(0, Math.min(spacingRef.current + drawingBox.bottom - buttonBox.bottom, room)));
      }
      spacingRef.current = next;
      setSpacing(next);
    };

    const observer = new ResizeObserver(align);
    observer.observe(drawing.parentElement);
    observer.observe(column);
    window.addEventListener('resize', align);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', align);
    };
  }, [uuid])

  return (
    <>
      <div style={{ height: spacing }}></div>
      <button ref={buttonRef} id={`RedrawLayoutButton_${uuid}`} onClick={handleClick} className="btn btn-default btn-lg form-control redraw-btn redraw_btn_layout">
        <img width="40" disabled={redrawInProgress} src={redrawInProgress ? window.img_redraw_in_action : window.img_redraw_ready} />
          {window.wording_redraw}
      </button>
    </>
  )
};

export default RedrawLayoutButton;
